// src/models/produtos/VariacaoItem.js
// models/produtos/VariacaoItem.js
export class VariacaoItem {
    constructor(id = 0, descricao = '') {
        this.id = id;
        this.descricao = descricao;
        this.variacaoId = null;
        this.isDefault = false;
        this.valorAdicional = 0;
    }
}
